// extracted by mini-css-extract-plugin
export default {"HomePage":"BlogPage-module--HomePage--2NqXx","subscribeWrapper":"BlogPage-module--subscribeWrapper--39Dp5"};